<template>
    <div class="all-height d-flex justify-center" data-testid="financialclose_automation_bots_component__root">
      <div class="all-width" data-testid="financialclose_automation_bots_component__main-panel">
        <v-card class="shadow-off" loader-height="2" :loading="loading" :disabled="loading" data-testid="financialclose_automation_bots_component__card">
          <v-card-text data-testid="financialclose_automation_bots_component__card-body">
      <div class="" data-testid="financialclose_automation_bots_component__header-panel">
        <div class="d-flex" data-testid="financialclose_automation_bots_component__breadcrumbs">
          <router-link
            class="mb-1 text-decoration-none financialclose-automation-bots__breadcrumb-home"
            :to="{ path: FC_ROUTES.HOME, query: $route.query }"
            data-testid="financialclose_automation_bots_component__breadcrumb-home"
          >Home</router-link>
          <p class="px-2 mb-1" data-testid="financialclose_automation_bots_component__breadcrumb-sep">/</p>
          <p class="mb-1" data-testid="financialclose_automation_bots_component__breadcrumb-desc">{{ metadata.description }}</p>
        </div>
        <div class="d-flex" data-testid="financialclose_automation_bots_component__titlebar">
          <h3 class="font-weight-medium" data-testid="financialclose_automation_bots_component__title">Borrowing Schedule</h3>
          <v-btn class="shadow-off ml-2" icon
            @click="refreshData()" data-testid="financialclose_automation_bots_component__refresh-btn"><v-icon>mdi-refresh</v-icon></v-btn>
        </div>
      </div>
  
            <div v-if="loading && (!metadata._id || !botdetails._id)" data-testid="financialclose_automation_bots_component__skeleton-loader">
              <v-skeleton-loader type="table-heading, list-item-two-line, article, article"></v-skeleton-loader>
            </div>
            <div class="gray--text d-flex align-center justify-center all-width" v-else-if="!botdetails._id" data-testid="financialclose_automation_bots_component__no-permission-panel">
                <div class="body-1 mb-4" data-testid="financialclose_automation_bots_component__no-permission-msg">You do not have permission to use the Borrowing Schedule {{$constants.BOT_NAME}}</div>
            </div>
            <div v-else-if="metadata.stage === 3 && Object.keys(rundetails).length === 0" class="pa-8 title text-center grey--text" data-testid="financialclose_automation_bots_component__not-run-msg">
              {{$constants.BOT_NAME}} did not run 
            </div>
            <div v-else data-testid="financialclose_automation_bots_component__main-content">
              <div v-if="metadata.stage !== 3" data-testid="financialclose_automation_bots_component__alerts-panel">
                <v-alert v-if="!savedParameters && hasParameters" type="" color="caccounting" text dense border="left" data-testid="financialclose_automation_bots_component__alert-save-params">Save the Input parameters to
                  proceed</v-alert>
                <v-alert v-else-if="!savedFiles && hasFiles" type="" color="caccounting" text dense border="left" data-testid="financialclose_automation_bots_component__alert-upload-files">Upload all the required files to start
                  the analysis</v-alert>
              </div>
              <div v-if="(processedFiles || !hasFiles) && (savedParameters || !hasParameters) && metadata.stage !== 3" class="d-flex" data-testid="financialclose_automation_bots_component__run-toolbar">
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="Object.keys(rundetails).length === 0" class="ml-2 shadow-off white--text "   @click="startRun()" data-testid="financialclose_automation_bots_component__start-run-btn">
                  <v-icon class="mr-1">mdi-play</v-icon>
                  <span>Start Run</span>
                </v-btn>
                <v-btn color="primary" v-else class="ml-2 shadow-off white--text  "  @click="startRun()" data-testid="financialclose_automation_bots_component__run-btn">
                  <v-icon class="mr-1">mdi-play</v-icon>
                  <span>Run</span>
                </v-btn>
              </div>
              <v-tabs v-model="tab" color="caccounting" height="30" data-testid="financialclose_automation_bots_component__tabs">
                <v-tab :key="1" v-if="hasParameters" class="text-transform-none justify-start" data-testid="financialclose_automation_bots_component__tab-input-parameters"><v-icon
                    class="mr-2">mdi-play-box-multiple-outline</v-icon>Input Parameters</v-tab>
                <v-tab :key="2" v-if="savedParameters || (!hasParameters && hasFiles)" class="text-transform-none justify-start" data-testid="financialclose_automation_bots_component__tab-files"><v-icon
                    class="mr-2">mdi-cloud-upload-outline</v-icon>Files</v-tab>
                <v-tab :key="3" class="text-transform-none justify-start"
                  v-if="(savedParameters || !hasParameters) && Object.keys(rundetails).length > 0"
                  @click="generateAnnexurelist(selectedresulttab)" data-testid="financialclose_automation_bots_component__tab-summary"><v-icon
                    class="mr-2">mdi-format-list-bulleted</v-icon>Summary</v-tab>
                <v-tab :key="4" class="text-transform-none justify-start"
                  v-if="(savedParameters || !hasParameters) && Object.keys(rundetails).length > 0"
                  @click="generateScheduleAnnexurelist(selectedresulttab)" data-testid="financialclose_automation_bots_component__tab-schedule">
                  <v-icon class="mr-2">mdi-file-excel</v-icon>Schedule
                </v-tab>
                <v-tab :key="5" class="text-transform-none justify-start"
                  v-if="(savedParameters || !hasParameters) && Object.keys(rundetails).length > 0"
                  @click="generateJournalEntries(selectedresulttab)" data-testid="financialclose_automation_bots_component__tab-journal-entries">
                  <v-icon class="mr-2">mdi-file-document</v-icon>Journal Entries
                </v-tab>
              </v-tabs>
              <v-divider data-testid="financialclose_automation_bots_component__tabs-divider"></v-divider>
              <v-tabs-items v-model="tab" data-testid="financialclose_automation_bots_component__tab-panels">
                <v-tab-item :key="1" v-if="hasParameters" data-testid="financialclose_automation_bots_component__tab-panel-input-parameters"> 
                  <InputParamerter class="mt-4" :parameter="setupList.parameter" :parametervalue="inputparametersvalues" :editable="metadata.stage !== 3"
                    :userType="false" :apiParam="'/v2/bot/analysis/storeinputparameter/' + botdetails._id"
                    :pid="id"
                    @startloading="loading = true" @stoploading="loading = false" @reload="refreshData()"
                    data-testid="financialclose_automation_bots_component__inputparamerter-component" />
                </v-tab-item>
                <v-tab-item :key="2" data-testid="financialclose_automation_bots_component__tab-panel-files">
                  <FileUploads 
                    :files="setupList.file"  
                    :filevalues="uploaddetails" 
                    :editable="metadata.stage !== 3"
                    :storepath="'/v2/bot/analysis/storefile/' + botdetails._id"
                    :pid="id"
                    :fileproerr="fileprocesserrors"
                    :fileprostage="fileprocessstage" 
                    :fileuppercent="fileuploadpercent" 
                    :filesdataPros="filesdata"
                    :fileconfig="fileConfigInfo"
                    @reload="refreshData()" 
                    :right="right"
                    data-testid="financialclose_automation_bots_component__fileuploads-component"
                    />
                </v-tab-item>
                <v-tab-item :key="3" v-if="Object.keys(rundetails).length > 0" data-testid="financialclose_automation_bots_component__tab-panel-summary">
                  <div data-testid="financialclose_automation_bots_component__summary-panel">
                    <div class="d-flex my-2">
                      <div style="min-width: 170px; max-width: 170px">
                        <div v-if="Object.keys(rundetails).length > 1" data-testid="financialclose_automation_bots_component__summary-verification-list">
                          <template v-for="(v, k) in verificationlist">
                            <div :key="k" :class="`${selectedresulttab === k
                              ? 'border-left-primary'
                              : 'border-left-transparent'
                              }`" :data-testid="`financialclose_automation_bots_component__summary-verification-row-${k}`">
                              <div @click="selectedresulttab = k; generateAnnexurelist(v);"
                                :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedresulttab === k ? 'grey lighten-4' : ''}`"
                                :data-testid="`financialclose_automation_bots_component__summary-verification-row-btn-${k}`">
                                <div class="mr-2" :data-testid="`financialclose_automation_bots_component__summary-verification-row-status-${k}`">
                                  <v-tooltip bottom content-class="tooltip-bottom"
                                    v-if="(rundetails[v._id] || {}).stage === 1">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="success">mdi-check-circle</v-icon>
                                    </template>
                                    <span>Completed</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else-if="
                                    (rundetails[v._id] || {}).stage === 4
                                  ">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="error">mdi-radiobox-marked</v-icon>
                                    </template>
                                    <span>Currently running</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="info">mdi-timer-sand</v-icon>
                                    </template>
                                    <span>Pending</span>
                                  </v-tooltip>
                                </div>
                                <div :data-testid="`financialclose_automation_bots_component__summary-verification-row-name-${k}`">
                                  {{ v.name }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div v-else data-testid="financialclose_automation_bots_component__summary-annexure-list-panel">
                          <v-btn color="primary" class="mb-4 shadow-off" @click="downloadResult()" data-testid="financialclose_automation_bots_component__summary-download-btn">
                            <v-icon class="mr-1">mdi-file-excel</v-icon>
                            <span>Download Excel</span>
                          </v-btn>                      
                          <div class="" style="max-height:70vh; overflow:scroll" data-testid="financialclose_automation_bots_component__summary-annexure-list">
                            <template v-for="(v, k) in summaryAnnexures">
                              <div :key="k" :class="`${selectedannexure === v.value ? 'border-left-primary': 'border-left-transparent'}`" :data-testid="`financialclose_automation_bots_component__summary-annexure-row-${k}`">
                                <div @click="selectedannexure = v.value; readAnnexure(v.value,(verificationlist[selectedresulttab] || {})._id)"
                                  :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedannexure === v.value ? 'grey lighten-4' : ''}`"
                                  :data-testid="`financialclose_automation_bots_component__summary-annexure-row-btn-${k}`">
                                  <div :data-testid="`financialclose_automation_bots_component__summary-annexure-row-name-${k}`">
                                    {{ v.name }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1 px-4" style="min-width: 0">
                        <div class="d-flex" data-testid="financialclose_automation_bots_component__summary-table-toolbar">
                          <lb-dropdown v-if="Object.keys(rundetails).length > 1" label="Annexures" v-model="selectedannexure" :items="summaryAnnexures" @change="
                            readAnnexure(
                              selectedannexure,
                              (verificationlist[selectedresulttab] || {})._id
                            )
                          " data-testid="financialclose_automation_bots_component__summary-table-dropdown" />
                          <v-spacer class="flex-grow-1"></v-spacer>
                        </div>
                        <div class="" v-if="currentannexuredata.length > 0" data-testid="financialclose_automation_bots_component__summary-table-region">
                          <v-simple-table dense class="simple-table border-on" :fixed-header="true" :height="tableHeight" data-testid="financialclose_automation_bots_component__summary-table">
                            <template v-slot:default>
                              <thead class="tableHeaderBg" data-testid="financialclose_automation_bots_component__summary-table-header">
                                <tr class="">
                                  <template v-for="(v, k) in currentannexuredata[0]">
                                    <th class="tableHeaderBg" :key="k" v-if="k !== '_id'" :data-testid="`financialclose_automation_bots_component__summary-table-header-cell-${k}`">
                                      {{ (k || "").replaceAll("_", " ") }}
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody data-testid="financialclose_automation_bots_component__summary-table-body">
                                <tr v-for="(v, k) in currentannexuredata" :key="k" :data-testid="`financialclose_automation_bots_component__summary-table-row-${k}`">
                                  <template v-for="(vv, kk) in currentannexuredata[0]">
                                    <td :key="kk" v-if="kk !== '_id'" :data-testid="`financialclose_automation_bots_component__summary-table-cell-${k}-${kk}`">
                                      {{
                                        typeof v[kk] === "number"
                                        ? $nova.formatNumber(v[kk].toFixed(0))
                                        : v[kk]
                                      }}
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div v-else class="text-center grey--text title pa-6" data-testid="financialclose_automation_bots_component__summary-table-empty">
                          No data available
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item :key="4" v-if="Object.keys(rundetails).length > 0" data-testid="financialclose_automation_bots_component__tab-panel-schedule">
                  <div data-testid="financialclose_automation_bots_component__schedule-panel">
                    <div class="d-flex my-2">
                      <div style="min-width: 170px; max-width: 170px">
                        <div v-if="Object.keys(rundetails).length > 1" data-testid="financialclose_automation_bots_component__schedule-verification-list">
                          <template v-for="(v, k) in verificationlist">
                            <div :key="k" :class="`${selectedresulttab === k
                              ? 'border-left-primary'
                              : 'border-left-transparent'
                              }`" :data-testid="`financialclose_automation_bots_component__schedule-verification-row-${k}`">
                              <div @click="selectedresulttab = k; generateScheduleAnnexurelist(v);"
                                :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedresulttab === k ? 'grey lighten-4' : ''}`"
                                :data-testid="`financialclose_automation_bots_component__schedule-verification-row-btn-${k}`">
                                <div class="mr-2" :data-testid="`financialclose_automation_bots_component__schedule-verification-row-status-${k}`">
                                  <v-tooltip bottom content-class="tooltip-bottom"
                                    v-if="(rundetails[v._id] || {}).stage === 1">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="success">mdi-check-circle</v-icon>
                                    </template>
                                    <span>Completed</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else-if="
                                    (rundetails[v._id] || {}).stage === 4
                                  ">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="error">mdi-radiobox-marked</v-icon>
                                    </template>
                                    <span>Currently running</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="info">mdi-timer-sand</v-icon>
                                    </template>
                                    <span>Pending</span>
                                  </v-tooltip>
                                </div>
                                <div :data-testid="`financialclose_automation_bots_component__schedule-verification-row-name-${k}`">
                                  {{ v.name }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div v-else data-testid="financialclose_automation_bots_component__schedule-annexure-list-panel">
                          <v-btn color="primary" class="mb-4 shadow-off" @click="downloadResult()" data-testid="financialclose_automation_bots_component__schedule-download-btn">
                            <v-icon class="mr-1">mdi-file-excel</v-icon>
                            <span>Download Excel</span>
                          </v-btn>                      
                          <div class="" style="max-height:70vh; overflow:scroll" data-testid="financialclose_automation_bots_component__schedule-annexure-list">
                            <template v-for="(v, k) in scheduleAnnexures">
                              <div :key="k" :class="`${selectedannexure === v.value ? 'border-left-primary': 'border-left-transparent'}`" :data-testid="`financialclose_automation_bots_component__schedule-annexure-row-${k}`">
                                <div @click="selectedannexure = v.value; readAnnexure(v.value,(verificationlist[selectedresulttab] || {})._id)"
                                  :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedannexure === v.value ? 'grey lighten-4' : ''}`"
                                  :data-testid="`financialclose_automation_bots_component__schedule-annexure-row-btn-${k}`">
                                  <div :data-testid="`financialclose_automation_bots_component__schedule-annexure-row-name-${k}`">
                                    {{ v.name }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1 px-4" style="min-width: 0">
                        <div class="d-flex" data-testid="financialclose_automation_bots_component__schedule-table-toolbar">
                          <lb-dropdown v-if="Object.keys(rundetails).length > 1" label="Annexures" v-model="selectedannexure" :items="scheduleAnnexures" @change="
                            readAnnexure(
                              selectedannexure,
                              (verificationlist[selectedresulttab] || {})._id
                            )
                          " data-testid="financialclose_automation_bots_component__schedule-table-dropdown" />
                          <v-spacer class="flex-grow-1"></v-spacer>
                        </div>
                        <div class="" v-if="currentannexuredata.length > 0" data-testid="financialclose_automation_bots_component__schedule-table-region">
                          <v-simple-table dense class="simple-table border-on" :fixed-header="true" :height="tableHeight" data-testid="financialclose_automation_bots_component__schedule-table">
                            <template v-slot:default>
                              <thead class="tableHeaderBg" data-testid="financialclose_automation_bots_component__schedule-table-header">
                                <tr class="">
                                  <template v-for="(v, k) in currentannexuredata[0]">
                                    <th class="tableHeaderBg" :key="k" v-if="k !== '_id'" :data-testid="`financialclose_automation_bots_component__schedule-table-header-cell-${k}`">
                                      {{ (k || "").replaceAll("_", " ") }}
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody data-testid="financialclose_automation_bots_component__schedule-table-body">
                                <tr v-for="(v, k) in currentannexuredata" :key="k" :data-testid="`financialclose_automation_bots_component__schedule-table-row-${k}`">
                                  <template v-for="(vv, kk) in currentannexuredata[0]">
                                    <td :key="kk" v-if="kk !== '_id'" :data-testid="`financialclose_automation_bots_component__schedule-table-cell-${k}-${kk}`">
                                      {{
                                        typeof v[kk] === "number"
                                        ? $nova.formatNumber(v[kk].toFixed(0))
                                        : v[kk]
                                      }}
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div v-else class="text-center grey--text title pa-6" data-testid="financialclose_automation_bots_component__schedule-table-empty">
                          No data available
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item :key="5" v-if="Object.keys(rundetails).length > 0" data-testid="financialclose_automation_bots_component__tab-panel-journal-entries">
                  <div data-testid="financialclose_automation_bots_component__journal-entries-panel">
                    <div class="d-flex my-2">
                      <div style="min-width: 170px; max-width: 170px">
                        <div v-if="Object.keys(rundetails).length > 1" data-testid="financialclose_automation_bots_component__journal-entries-verification-list">
                          <template v-for="(v, k) in verificationlist">
                            <div :key="k" :class="`${selectedresulttab === k
                              ? 'border-left-primary'
                              : 'border-left-transparent'
                              }`" :data-testid="`financialclose_automation_bots_component__journal-entries-verification-row-${k}`">
                              <div @click="selectedresulttab = k; generateAnnexurelist(v);"
                                :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedresulttab === k ? 'grey lighten-4' : ''}`"
                                :data-testid="`financialclose_automation_bots_component__journal-entries-verification-row-btn-${k}`">
                                <div class="mr-2" :data-testid="`financialclose_automation_bots_component__journal-entries-verification-row-status-${k}`">
                                  <v-tooltip bottom content-class="tooltip-bottom"
                                    v-if="(rundetails[v._id] || {}).stage === 1">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="success">mdi-check-circle</v-icon>
                                    </template>
                                    <span>Completed</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else-if="
                                    (rundetails[v._id] || {}).stage === 4
                                  ">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="error">mdi-radiobox-marked</v-icon>
                                    </template>
                                    <span>Currently running</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="info">mdi-timer-sand</v-icon>
                                    </template>
                                    <span>Pending</span>
                                  </v-tooltip>
                                </div>
                                <div :data-testid="`financialclose_automation_bots_component__journal-entries-verification-row-name-${k}`">
                                  {{ v.name }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div v-else data-testid="financialclose_automation_bots_component__journal-entries-annexure-list-panel">
                          <v-btn color="primary" class="mb-4 shadow-off" @click="downloadResult()" data-testid="financialclose_automation_bots_component__journal-entries-download-btn">
                            <v-icon class="mr-1">mdi-file-excel</v-icon>
                            <span>Download Excel</span>
                          </v-btn>                      
                          <div class="" style="max-height:70vh; overflow:scroll" data-testid="financialclose_automation_bots_component__journal-entries-annexure-list">
                            <template v-for="(v, k) in journalEntriesAnnexures">
                              <div :key="k" :class="`${selectedannexure === v.value ? 'border-left-primary': 'border-left-transparent'}`" :data-testid="`financialclose_automation_bots_component__journal-entries-annexure-row-${k}`">
                                <div @click="selectedannexure = v.value; readAnnexure(v.value,(verificationlist[selectedresulttab] || {})._id)"
                                  :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedannexure === v.value ? 'grey lighten-4' : ''}`"
                                  :data-testid="`financialclose_automation_bots_component__journal-entries-annexure-row-btn-${k}`">
                                  <div :data-testid="`financialclose_automation_bots_component__journal-entries-annexure-row-name-${k}`">
                                    {{ v.name }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1 px-4" style="min-width: 0">
                        <div class="d-flex" data-testid="financialclose_automation_bots_component__journal-entries-table-toolbar">
                          <lb-dropdown v-if="Object.keys(rundetails).length > 1" label="Annexures" v-model="selectedannexure" :items="journalEntriesAnnexures" @change="
                            readAnnexure(
                              selectedannexure,
                              (verificationlist[selectedresulttab] || {})._id
                            )
                          " data-testid="financialclose_automation_bots_component__journal-entries-table-dropdown" />
                          <v-spacer class="flex-grow-1"></v-spacer>
                        </div>
                        <div class="" v-if="currentannexuredata.length > 0" data-testid="financialclose_automation_bots_component__journal-entries-table-region">
                          <v-simple-table dense class="simple-table border-on" :fixed-header="true" :height="tableHeight" data-testid="financialclose_automation_bots_component__journal-entries-table">
                            <template v-slot:default>
                              <thead class="tableHeaderBg" data-testid="financialclose_automation_bots_component__journal-entries-table-header">
                                <tr class="">
                                  <template v-for="(v, k) in currentannexuredata[0]">
                                    <th class="tableHeaderBg" :key="k" v-if="k !== '_id'" :data-testid="`financialclose_automation_bots_component__journal-entries-table-header-cell-${k}`">
                                      {{ (k || "").replaceAll("_", " ") }}
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody data-testid="financialclose_automation_bots_component__journal-entries-table-body">
                                <tr v-for="(v, k) in currentannexuredata" :key="k" :data-testid="`financialclose_automation_bots_component__journal-entries-table-row-${k}`">
                                  <template v-for="(vv, kk) in currentannexuredata[0]">
                                    <td :key="kk" v-if="kk !== '_id'" :data-testid="`financialclose_automation_bots_component__journal-entries-table-cell-${k}-${kk}`">
                                      {{
                                        typeof v[kk] === "number"
                                        ? $nova.formatNumber(v[kk].toFixed(0))
                                        : v[kk]
                                      }}
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div v-else class="text-center grey--text title pa-6" data-testid="financialclose_automation_bots_component__journal-entries-table-empty">
                          No data available
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </template>
  
  <script>
  import InputParamerter from '../../../../../views/conserve/InputParamerter.vue';
  import FileUploads from '../../../../../views/conserve/FileUploads.vue';
  import { FC_ROUTES } from '../../../utils/constants';
  export default {
    name: 'financialclose_automation_bots_component',
    // props: ['props'],
    data: function () {
      return {
        FC_ROUTES,
        right:"financialclose_pbc_project",
        project: "",
        loading: false,
        id: "",
        tab: 0,
        metadata: {},
        botproject: {},
        botdetails: {},
        setupList: {},
        verificationlist: [],
        hasParameters: false,
        savedParameters: false,
        inputparametersvalues: {},
        uploaddetails: {},
        fileuploaddata: {},
        fileprocesserrors: {},
        fileuploadpercent: {},
        fileprocessstage: {},
        filesdata: {},
        processedFiles: false,
        savedFiles: false,
        hasFiles: false,
        rundetails: {},
        annexurelist: [],
        selectedresulttab: 0,
        selectedannexure: "",
        currentannexuredata: [],
        annexuredata: {},
        fileConfigInfo: {},
        tableHeight:''
      }
    },
    props: {
      botid: {
        type: String,
        default: ""
      },
    },
    computed: {
      summaryAnnexures(){
        return this.annexurelist.filter(a => (a.name || '').toLowerCase().includes('summary'));
      },
      scheduleAnnexures(){
        return this.annexurelist.filter(a => (a.name || '').toLowerCase().includes('schedule'));
      },
      journalEntriesAnnexures(){
        return this.annexurelist.filter(a => (a.name || '').toLowerCase().includes('journal'));
      }
    },
    components: {
     FileUploads ,InputParamerter
    },
    created() {
      this.refreshData();
      this.tableHeight = window.innerHeight - 250;
    },
    activated() {
      this.refreshData();
    },
    methods: {
      refreshData() {
        this.id = this.$route.params.id || "";
        this.userid = this.$store.state.user.id;
        this.currentannexuredata = [];
        this.annexuredata = {};
        this.getData();
      },
      getData() {
        this.loading = true;
        this.project = this.$route.params.id;
  
        return this.axios.post("/v2/bot/analysis/getbotdetails/" + this.id).then(dt => {
          if (dt.data.status === "success" && dt.data.data.length > 0) {
            let data = dt.data.data[0] || {}
            this.metadata = data.metadata || {};
            this.userlist = [];
            this.userlist = this.metadata.userlist || [];
            this.managerlist = [];
            this.managerlist = this.metadata.managerlist || [];
            this.stage = this.metadata.stage;
          }
        }).catch(error => {
          this.$store.commit("sbError", error?.response?.data?.message || error?.message || error || "Unknown error!");
        }).finally(() => {
          this.loading = false;
          this.loadBot();
        })
      },
      generateAnnexurelist: function (index = 0) {
        this.annexurelist = [];
        this.currentannexuredata = [];
        this.selectedannexure = "";

        let ndata = [];
        let selectedverification = this.verificationlist[index] || {};
        let rundata = this.rundetails[selectedverification._id] || {};
        if (Object.keys(rundata).length > 0) {
          for (const el of (rundata.annexure || [])) {
            if ((el.name || '').toLowerCase().includes('summary')) {
              ndata.push({ name: el.name, value: el.collection });
            }
          }
          this.annexurelist = ndata;
          if (ndata.length > 0) {
            this.selectedannexure = ndata[0].value;
            this.readAnnexure(this.selectedannexure, selectedverification._id);
          }
        }
      },
      generateScheduleAnnexurelist(index = 0) {
        let ndata = [];
        let selectedverification = this.verificationlist[index] || {};
        let rundata = this.rundetails[selectedverification._id] || {};

        if (Object.keys(rundata).length > 0) {
          let annxdata = rundata;
          for (let el of annxdata.annexure || []) {
            if ((el.name || '').toLowerCase().includes('schedule')) {
              ndata.push({ name: el.name, value: el.collection });
            }
          }

          this.annexurelist = ndata;
          if (ndata.length > 0) {
            this.selectedannexure = ndata[0].value;
            this.readAnnexure(this.selectedannexure, selectedverification._id);
          }
        }
      },
      generateJournalEntries(index = 0) {
        let ndata = [];
        let selectedverification = this.verificationlist[index] || {};
        let rundata = this.rundetails[selectedverification._id] || {};

        if (Object.keys(rundata).length > 0) {
          let annxdata = rundata;
          for (let el of annxdata.annexure || []) {
            if ((el.name || '').toLowerCase().includes('journal')) {
              ndata.push({ name: el.name, value: el.collection });
            }
          }

          this.annexurelist = ndata;
          if (ndata.length > 0) {
            this.selectedannexure = ndata[0].value;
            this.readAnnexure(this.selectedannexure, selectedverification._id);
          }
        }
      },
      readAnnexure(c, v) {
        if(c){
          // if (this.annexuredata[c]) {
          //   this.currentannexuredata = this.annexuredata[c];
          // } else {
            this.loading = true;
            Promise.resolve()
              .then(() => {
                return this.axios.post("/v2/bot/analysis/readannexure/" + this.botdetails._id + "/c/" + c + "/v/" + v);
              })
              .then((dt) => {
                if (dt.data.status === "success") {
                  this.annexuredata[c] = dt.data.data;
                  this.currentannexuredata = this.annexuredata[c];
                } else throw new Error(dt.data.message || "Error reading annexure");
              })
              .catch((err) => {
                this.$store.commit("sbError", err.message || err || "Unknown error!");
                this.currentannexuredata = [];
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
              });
          // }
        }
      },
      loadBot() {
        this.loading = true;
        return this.axios.post("/v2/bot/analysis/loadbotdetails/" + this.id + "/b/" + this.botid).then(dt => {
          if (dt.data.status === "success" && dt.data.data.length > 0) {
            let data = dt.data.data[0] || {};
            this.botdetails = data.metadata || {};
            this.uploaddetails = data.uploaddetails || {};
            this.setupList = data.setup || {};
            this.verificationlist = this.setupList.verification || {};
            this.inputparametersvalues = this.botdetails.inputparameter || {};
            this.fileConfigInfo = this.setupList?.fileconfig || {};
            this.rundetails = {};
            for (const i of data.rundetails || []) {
              this.rundetails[i.verification] = i;
            }
            this.generateAnnexurelist();
  
            // to check if inputparameter are available and if the same is saved
            this.savedParameters = false;
            if ((this.setupList.parameter || []).length > 0) {
              this.hasParameters = true;
              let allparametersaved = true;
              for (let ele of this.setupList.parameter) {
                if (!Object.hasOwnProperty.call((this.botdetails.inputparameter || {}), ele._id)) {
                  allparametersaved = false;
                }
              }
              this.savedParameters = allparametersaved;
            } else {
              this.hasParameters = false;
            }
  
            // set default input parameter values
            let availableids = [];
            for (const k in this.inputparametersvalues) {
              if (Object.hasOwnProperty.call(this.inputparametersvalues, k)) {
                availableids.push(k);
              }
            }
            for (const i of this.setupList.parameter || []) {
              if (availableids.indexOf(i._id) === -1) {
                if (
                  Object.hasOwnProperty.call(
                    this.setupList.inputparameterconfig || {},
                    i._id
                  )
                )
                  this.inputparametersvalues[i._id] = (
                    this.setupList.inputparameterconfig[i._id] || {}
                  ).value;
                else this.inputparametersvalues[i._id] = i?.value;
              }
            }
  
            // to check if files are available and if the same is saved and also flag processing errors
            if ((this.setupList.file || []).length > 0) {
              this.hasFiles = true;
              let allfileprocessed = true;
              let allfilesaved = true;
              let availablefiles = [];
              for (const i of this.botdetails.files || []) {
                availablefiles.push(i.fileid);
              }
              for (let ele of this.setupList.file) {
                let id = ele._id;
                if ((this.uploaddetails[id] || {}).processed !== 1) {
                  allfileprocessed = false;
                }
                if ((this.uploaddetails[id] || {}).processed === -1) this.fileprocesserrors[id] = "Error while processing file";
                if (availablefiles.indexOf(id) === -1 || (this.uploaddetails[id].processed || 0) === -1) allfilesaved = false;
              }
              this.savedFiles = allfilesaved;
              this.processedFiles = allfileprocessed;
            } else {
              this.hasFiles = false;
            }
          }
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
        }).finally(() => {
          this.loading = false;
        })
      },
      startRun() {
        this.loading = true;
        const pid = this.id || this.$route.params.id || '';
        this.axios
          .post("/v2/bot/analysis/startrun/" + this.botdetails._id, {
            pid,
            data: { pid },
          })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.$store.commit("sbSuccess", "Run Started");
              this.loadBot();
            } else throw new Error("Error starting run");
          })
          .catch((err) => {
            this.$store.commit("sbError", err?.response?.data?.message || err?.message || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      downloadResult() {
        this.loading = true;
        this.axios.post("/v2/bot/analysis/downloadfile/"+this.botdetails._id).then(dt => {
          if(dt.data.status === "success"){
            let data = dt.data.data[0] || {};
            if(data.stage === 0 || data.stage === 4) this.$store.commit("sbSuccess", "File is being generated please try after sometime");
            else if(data.stage === 2) this.$store.commit("sbSuccess", "There was an error while generating file");
            else if(data.upload) this.$nova.downloadFile(data.upload);
            else return  "no file found to download"
          }else {
            throw new Error (dt.data.message || "Error re-opening project");
          }
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = false;
        })
      },
       saveInputParameters() {
         this.loading = true;
        const pid = this.id || this.$route.params.id || '';
        let objectInput = { inputparameter: this.inputparametersvalues, pid };
        this.axios
          .post("/v2/bot/analysis/storeinputparameter/" + this.botdetails._id, {
            pid,
            data: objectInput,
          })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.$store.commit("sbSuccess", "Input Parameters Updated");
              this.loadBot();
              this.loading = false;
            } else throw new Error("Error updating input parameters");
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
             this.loading = false;
          });
      },
    },
    watch: {
    }
  }
  </script>

<style scoped>
.financialclose-automation-bots__breadcrumb-home {
  color: inherit;
}
</style>
  